'use client';

import { type QuizOption as QuizOptionType } from '../../../../../../modules/quiz/types';
import { QuizOptionCard } from '../QuizOptionCard';
import { QuizOptionColor } from '../QuizOptionColor';

import {
  RadioSelector,
  type RadioSelectorState,
} from '@/components/RadioSelector';

type QuizOptionProps = {
  option: QuizOptionType;
  selectedValue: string | null;
  onSelect: () => void;
  label: string;
  labelPosition: 'top-left' | 'bottom-center';
  error: boolean;
  name: string;
  onHomepage?: boolean;
};

function getOptionState(
  value: string,
  selectedValue: string | null
): RadioSelectorState {
  if (selectedValue === null) {
    return 'default';
  }
  if (selectedValue === value) {
    return 'selected';
  }
  return 'faded';
}

export function QuizOption({
  option,
  selectedValue,
  onSelect,
  label,
  error,
  labelPosition,
  name,
  onHomepage,
}: QuizOptionProps) {
  const state = getOptionState(option.value, selectedValue);

  return (
    <RadioSelector
      name={name}
      value={option.value}
      state={state}
      onChange={onSelect}
      aria-labelledby={option.value}
      error={error}
      hideIndicator={onHomepage}
      hoverable={onHomepage}
    >
      {option.type === 'image' && option.imageSrc && (
        <QuizOptionCard
          imageSrc={option.imageSrc}
          imageSrcMobile={option.imageSrcMobile}
          imageAlt={label}
          label={label}
          labelId={option.value}
          labelPosition={labelPosition}
        />
      )}
      {option.type === 'color' && option.colors && (
        <QuizOptionColor
          colors={option.colors}
          label={label}
          labelId={option.value}
        />
      )}
    </RadioSelector>
  );
}
